/**
 * @generated SignedSource<<df903e91c44c4d909eeea6be456c943f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues$data = {
  readonly downloadResultUrl: string | null | undefined;
  readonly task: {
    readonly id: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues";
};
export type exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues$key = {
  readonly " $data"?: exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues",
  "selections": [
    {
      "concreteType": "JiraIssueExportTask",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "downloadResultUrl"
    }
  ],
  "type": "JiraIssueExportTaskCompleted"
};

(node as any).hash = "c7fbec2637efdd781e8042c4b9ed971d";

export default node;
